import { Typography } from '../typography/typography';
import { ErrorMessageInputProps } from './types';

export const ErrorMessageInput: React.FC<ErrorMessageInputProps> = ({ error, hint }) => {
    return (
        <>
            {Boolean(error) && (
                <Typography size='body2_short' color='error_60'>
                    {error}
                </Typography>
            )}
            {Boolean(hint) && Boolean(!error) && (
                <Typography size='body2_short' color='neutral_50'>
                    {hint}
                </Typography>
            )}
        </>
    );
};
